import { SAVE_EMAIL } from './types'

export const saveEmail = (email) => dispatch => {
  dispatch({ type: SAVE_EMAIL, email })
}
